module.exports = __webpack_public_path__ + "img/ship.fed82378.gif";